import type { ResolveCircuitBoard } from "./types";

export const resolveCircuitBoard: ResolveCircuitBoard = ({
  feedPoint,
  zoneBoard,
  runBoard,
  mainLabel,
  isLive,
  isStruck,
  roleOf,
}) => {
  if (feedPoint && isLive(feedPoint)) return { label: feedPoint, by: "yours" };
  if (zoneBoard) return { label: zoneBoard, by: "zone" };
  const main = mainLabel && isLive(mainLabel) ? mainLabel : null;
  // A struck board's runs fall back to the main board; only without one are they left unfed.
  if (runBoard && isStruck(runBoard)) {
    return main
      ? { label: main, by: "main", reason: "runBoardStruck" }
      : { label: runBoard, by: "struck" };
  }
  if (runBoard && main && runBoard !== main && roleOf(runBoard) === "viaMain") {
    return { label: main, by: "main", reason: "runBoardViaMain" };
  }
  if (runBoard && isLive(runBoard)) return { label: runBoard, by: "run" };
  if (main) {
    return { label: main, by: "main", reason: runBoard ? "runBoardNotOnPlan" : "noRunBoard" };
  }
  return { label: null, by: "unfed" };
};
